var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"mr-2",class:_vm.statusMeta.class,attrs:{"small":""}},[_vm._v("fas fa-circle")]),(_vm.showText)?_c('span',{domProps:{"textContent":_vm._s(_vm.statusMeta.text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }